import React from 'react';

const AboutUs = () => {


    return (
        <div>
            <h5>About us</h5>
            <hr />
            <div>
                <b>User management [UM]</b>
                <p>This application manages users, and other application such (BrandShare, Marcombox) are using those users in their portal.</p>
            </div>
        </div>
    );
}

export default AboutUs;